import { useTheme } from '@mui/material';
import Chart, { useChart } from 'src/components/chart';
import { ProductPriceLog } from 'src/type/product';
import { fNumber } from 'src/utils/format-number';
import { fDateTime } from 'src/utils/format-time';

type Props = {
  priceLogs?: ProductPriceLog[];
};

export default function GoldPriceChart({ priceLogs }: Props) {
  const theme = useTheme();

  const reversePriceLogs = [...(priceLogs || [])].reverse();

  const getTickAmount = (length: number) => {
    if (length < 4) {
      return length;
    }

    return length / 8;
  };

  const colors = [
    [theme.palette.success.light, theme.palette.success.main],
    [theme.palette.warning.light, theme.palette.warning.main],
  ];

  const category = reversePriceLogs?.map((log) => fDateTime(log.createdAt)) || [];

  const chartOptions = useChart({
    chart: {
      animations: {
        enabled: false,
      },
    },
    colors: colors.map((colr) => colr[1]),
    fill: {
      type: 'gradient',
      gradient: {
        colorStops: colors.map((colr) => [
          { offset: 0, color: colr[0], opacity: 1 },
          { offset: 100, color: colr[1], opacity: 1 },
        ]),
      },
    },
    yaxis: {
      labels: {
        formatter: (value: number) => `${fNumber(value)} `,
      },
    },
    xaxis: {
      categories: category,
      tickAmount: getTickAmount(category.length),
      labels: {
        show: false,
        rotate: 0,
      },
    },
    legend: {
      show: false,
    },
    tooltip: {
      y: {
        formatter: (value: number) => `${fNumber(value)} บาท`,
      },
    },
  });

  const series = [
    {
      name: 'รับซื้อ',
      data: reversePriceLogs?.map((log) => log.priceBuyPerUnit) || [],
    },
    {
      name: 'ขายออก',
      data: reversePriceLogs?.map((log) => log.priceSellPerUnit) || [],
    },
  ];
  return (
    <Chart dir="ltr" type="line" series={series} options={chartOptions} width="100%" height={240} />
  );
}
